import { Pipe, PipeTransform } from '@angular/core';

import { AnyFn, anyFnExec } from '../models';

@Pipe({
  name: 'anyFnExec',
})
export class AnyFnExecPipe implements PipeTransform {
  // `_revision` is unused on purpose: changing it makes the pure pipe re-run a
  // function whose result changed while its reference stayed the same.
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  transform(data: any, fn: AnyFn, _revision?: number): any {
    return anyFnExec(fn, data);
  }
}
